<template>
  <div data-component-group="filter-forms" data-component="events-assets">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      :is-global-country-filter="false"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Created Date"
        :config="dateConfig"
        :on-change="onChangeDate"
      />
    </FiltersForm>
  </div>
</template>

<script>
import FiltersForm from '../FiltersBase';
import { debounce, isNonEmptyStr } from '@/utils';
import { v1 as uuidv1 } from 'uuid';

const debouncer = debounce({
  id: uuidv1(),
  timeout: 500
});

export default {
  components: {
    FiltersForm,
  },
  data() {
    return {
      search: null,
      dates: '',
      dateConfig: {
        mode: 'range',
      },
    };
  },
  computed: {
    hasFilters() {
      const { search, dates } = this;
      return isNonEmptyStr(search) || isNonEmptyStr(dates);
    },
  },
  emits: ['filter', 'clearFilters'],
  methods: {
    onFilter() {
      const { search, dates } = this;
      this.$emit('filter', {
        search,
        dates,
      });
    },
    onClearFilters() {
      this.search = null;
      this.dates = '';
      this.$emit('clearFilters');
    },
    onChangeDate(dates) {
      this.dates = dates;
    },
  },
};
</script>